/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Selected_CountInputs */

const en_selected_count = /** @type {(inputs: Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

const fr_selected_count = /** @type {(inputs: Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} sélectionné(s)`)
};

const de_selected_count = /** @type {(inputs: Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ausgewählt`)
};

const it_selected_count = /** @type {(inputs: Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selezionati`)
};

const ru_selected_count = /** @type {(inputs: Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} выбрано`)
};

const es_selected_count = /** @type {(inputs: Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} seleccionado`)
};

const zh_cn2_selected_count = /** @type {(inputs: Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 已选择`)
};

const ja_selected_count = /** @type {(inputs: Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} が選択されました`)
};

const hi_selected_count = /** @type {(inputs: Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} चयनित`)
};

const pt_pt2_selected_count = /** @type {(inputs: Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selecionado`)
};

/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {Selected_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const selected_count = /** @type {((inputs: Selected_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selected_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_selected_count(inputs)
	if (locale === "de") return de_selected_count(inputs)
	if (locale === "it") return it_selected_count(inputs)
	if (locale === "ru") return ru_selected_count(inputs)
	if (locale === "es") return es_selected_count(inputs)
	if (locale === "zh-CN") return zh_cn2_selected_count(inputs)
	if (locale === "ja") return ja_selected_count(inputs)
	if (locale === "hi") return hi_selected_count(inputs)
	if (locale === "pt-PT") return pt_pt2_selected_count(inputs)
	return en_selected_count(inputs)
});